import './locales/i18n';
import 'simplebar/src/simplebar.css';
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/captions.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';
import './utils/mapboxgl';
import 'mapbox-gl/dist/mapbox-gl.css';
import 'react-quill-new/dist/quill.snow.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'react-lazy-load-image-component/src/effects/blur.css';

import { useEffect, useState } from 'react';
import { HelmetProvider } from 'react-helmet-async';
// ----------------------------------------------------------------------
import { BrowserRouter } from 'react-router-dom';
import { LicenseInfo } from '@mui/x-data-grid-pro';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import { AuthProvider } from './auth/SessionContext';
import { MotionLazyContainer } from './components/animate';
import { StyledChart } from './components/chart';
import LoadingAPI from './components/LoadingAPI';
import { PermissionContextProvider } from './components/permission-access/PermissionContext';
import ScrollToTop from './components/scroll-to-top';
import { SettingsProvider } from './components/settings';
import SnackbarProvider from './components/snackbar';
import { SearchFilterProvider } from './contexts/SearchFilterContext';
import { sendReactNativeMessage } from './utils/common';
import { GlobalDebug } from './utils/globalDebug';
import ThemeLocalization from './locales';
import { RootStore, RootStoreProvider, setupRootStore } from './models';
import Router from './routes';
import ThemeProvider from './theme';

// ----------------------------------------------------------------------

export default function App() {
  const [rootStore, setRootStore] = useState<RootStore | undefined>(undefined);
  useEffect(() => {
    // mui pro license
    LicenseInfo.setLicenseKey(
      'bd616d3c844e6bfa646b331756ccade3Tz0xMDM0NDgsRT0xNzY0ODM4MjA0MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI=',
    );

    (async () => {
      setupRootStore().then((store) => {
        setRootStore(store);
        sendReactNativeMessage({
          type: 'initUser',
          payload: null,
        });
      });
    })();
    if (window.localStorage.getItem('useDebug') !== 'true') {
      process.env.NODE_ENV === 'production' && GlobalDebug(false, false);
    }
  }, []);
  if (!rootStore) {
    return null;
  } else {
    return (
      <RootStoreProvider value={rootStore}>
        <AuthProvider>
          <PermissionContextProvider>
            <HelmetProvider>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <SettingsProvider>
                  <BrowserRouter>
                    <SearchFilterProvider>
                      <ScrollToTop />
                      <MotionLazyContainer>
                        <ThemeProvider>
                          <ThemeLocalization>
                            <SnackbarProvider>
                              <StyledChart />
                              <Router />
                              <LoadingAPI />
                            </SnackbarProvider>
                          </ThemeLocalization>
                        </ThemeProvider>
                      </MotionLazyContainer>
                    </SearchFilterProvider>
                  </BrowserRouter>
                </SettingsProvider>
              </LocalizationProvider>
            </HelmetProvider>
          </PermissionContextProvider>
        </AuthProvider>
      </RootStoreProvider>
    );
  }
}
